import includes from 'lodash/includes';
import { ToolsSecondaryMenuItems } from '../../ToolsSecondaryMenu.types';

import { ArchiAppPath } from '../../../../../../archiApps/ArchiAppPath';
import { ArcheidosPath } from '../../../../../../archeidos/ArcheidosPath';
import { ModelViewerPath } from '../../../../../../modelViewers/ModelViewerPath';

function getToolsActiveMenu(pathname: string): ToolsSecondaryMenuItems | null {
  if (includes(pathname, ArchiAppPath.index())) {
    return ToolsSecondaryMenuItems.ARCHI_APPS;
  }

  if (includes(pathname, ArcheidosPath.index())) {
    return ToolsSecondaryMenuItems.ARCHEIDOS;
  }

  if (includes(pathname, ModelViewerPath.index())) {
    return ToolsSecondaryMenuItems.MODEL_VIEWER;
  }

  return null;
}

export default getToolsActiveMenu;
